import React, { FC, useEffect, useState } from 'react';
import PaymentSubscriptionService from '../../services/payment-subscription.service';
import useService from '../../hooks/service.hook';
import { Button, Card, CardActions, CardContent, CircularProgress, Typography } from '@mui/material';
import { format, parse } from 'date-fns';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

export interface COEInvoiceProps {
  teamId: string | number;
  invoiceId: string;
  id?: string;
}

const COEInvoiceComponent: FC<COEInvoiceProps> = (props) => {
  const paymentSubscriptionService = useService(PaymentSubscriptionService);
  const [invoice, setInvoice] = useState<any>({});
  const [invoiceLoading, setInvoiceLoading] = useState(true);

  useEffect(() => {
    setInvoiceLoading(true);
    paymentSubscriptionService
      .getInvoice(props.teamId, props.invoiceId)
      .then((resp) => {
        setInvoiceLoading(false);
        setInvoice(resp.data.data);
      })
      .catch(() => {
        setInvoiceLoading(false);
      });
  }, []);

  const getDate = (dateString: string) => {
    const currentDate = parse(dateString, 'MM/dd/yyyy', new Date());
    return format(currentDate, 'MMMM yyyy');
  };

  const handleDownloadPDF = (pdfUrl: string) => {
    // Create a temporary anchor element
    const anchor = document.createElement('a');
    anchor.href = pdfUrl;
    anchor.download = 'invoice.pdf'; // Set the filename for the downloaded file

    // Programmatically trigger a click event on the anchor element
    document.body.appendChild(anchor);
    anchor.click();

    // Cleanup: Remove the anchor element
    document.body.removeChild(anchor);
  };

  return (
    <>
      {invoiceLoading ? (
        <CircularProgress style={{ alignSelf: 'center', width: 100, height: 100 }} />
      ) : (
        <Card sx={{ minWidth: 350 }}>
          <CardContent>
            <Typography variant="h3" color="text.secondary" gutterBottom>
              {`${getDate(invoice.date)} Invoice`}
            </Typography>
            <div style={{ display: 'flex', alignItems: 'center', margin: 20, justifyContent: 'center' }}>
              <CheckCircleOutlineIcon color="success" style={{ width: 75, height: 75 }} />
            </div>
            <Typography variant="h5" component="div" marginTop={3}>
              {`Status: Paid`}
            </Typography>
            <Typography variant="h5" component="div" marginTop={3}>
              {`Date: ${invoice.date}`}
            </Typography>
            <Typography variant="h5" component="div" marginTop={3}>
              {`Amount: ${invoice.amount}`}
            </Typography>
            <Typography sx={{ mb: 1.5 }} color="text.secondary" marginTop={3}>
              {`ID: ${invoice.id}`}
            </Typography>
          </CardContent>
          <CardActions>
            <Button onClick={() => handleDownloadPDF(invoice.pdf)}>Download full Invoice</Button>
          </CardActions>
        </Card>
      )}
    </>
  );
};

export default COEInvoiceComponent;
